import { UseControllerProps } from 'react-hook-form';
import {
    validEmailRegex,
    whiteSpaceMatcherRegex,
} from 'features/authentication/form-validations/form-validations';
import { FormErrorMessages } from 'features/authentication/types/types';

type Rules = UseControllerProps['rules'];

const MAX_FIELD_LENGTH = 128;

export const emailRules: Rules = {
    required: {
        value: true,
        message: 'This field is required',
    },
    maxLength: {
        value: MAX_FIELD_LENGTH,
        message: FormErrorMessages.RegularFieldLength,
    },
    validate: (val: string) => {
        const isValid = validEmailRegex.test(val) && !whiteSpaceMatcherRegex.test(val);
        if (!isValid) return FormErrorMessages.EmailInvalid;
        return true;
    },
};

export const validateEmail = (email: string | null): boolean => {
    if (!email) return false;
    if (email.length > MAX_FIELD_LENGTH) return false;
    return validEmailRegex.test(email) && !whiteSpaceMatcherRegex.test(email);
};

export const firstNameRules: Rules = {
    required: {
        value: true,
        message: 'First name is required',
    },
    maxLength: {
        value: MAX_FIELD_LENGTH,
        message: FormErrorMessages.RegularFieldLength,
    },
};

export const lastNameRules: Rules = {
    required: {
        value: true,
        message: 'Last name is required',
    },
    maxLength: {
        value: MAX_FIELD_LENGTH,
        message: FormErrorMessages.RegularFieldLength,
    },
};

export const companyRules: Rules = {
    required: {
        value: true,
        message: 'Company name is required',
    },
    maxLength: {
        value: MAX_FIELD_LENGTH,
        message: FormErrorMessages.RegularFieldLength,
    },
};

export const jobTitleRules: Rules = {
    required: {
        value: true,
        message: 'Job Title is required',
    },
    maxLength: {
        value: MAX_FIELD_LENGTH,
        message: FormErrorMessages.RegularFieldLength,
    },
};

export const phoneRules: Rules = {
    maxLength: {
        value: MAX_FIELD_LENGTH,
        message: FormErrorMessages.RegularFieldLength,
    },
};

export const passwordRules: Rules = {
    required: {
        value: true,
        message: 'This field is required',
    },
    minLength: {
        value: 10,
        message: 'Password cannot be less than 10 characters',
    },
    pattern: {
        value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).+$/,
        message:
            'Password must contain at least one uppercase letter, one lowercase letter, ' +
            'one number, and a special character.',
    },
};

export const isLowercaseLetterPresent = (value: string) => {
    return /[a-z]/.test(value);
};

export const isUppercaseLetterPresent = (value: string) => {
    return /[A-Z]/.test(value);
};

export const isUpperAndLowerCasePresent = (value: string) => {
    return isLowercaseLetterPresent(value) && isUppercaseLetterPresent(value);
};

export const isNumberPresent = (value: string) => {
    return /[0-9]/.test(value);
};

export const isSpecialCharacterPresent = (value: string) => {
    return /[!@#$%^&*(),.?":{}|<>]/.test(value);
};
